export enum ItemTypeEnum {
  AGGREGATOR = 'AGGREGATOR',
  COMBO = 'COMBO',
  OFFERS_BY_BRAND = 'OFFERS_BY_BRAND',
  SUGGESTED_LIST = 'SUGGESTED_LIST',
  SURPLUS_ITENS = 'SURPLUS_ITENS',
}
